import { ApiService } from "./ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

interface SearchAnalyticsItem {
  searchData: string;
  searchType: string;
  searchDateTime: string;
}

interface SearchAnalyticsDTO {
  analyticsList: SearchAnalyticsItem[];
}

export const SearchAnalyticsApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    saveSearchAnalytics: builder.mutation<ResultsDTO, { origin: string; body: SearchAnalyticsDTO }>({
      query: ({ origin, body }) => ({
        url: "/search-analytics/search-logs",
        method: "POST",
        headers: { origin },
        body,
      }),
    }),
    saveNoResultSearchAnalytics: builder.mutation<ResultsDTO, { origin: string; body: SearchAnalyticsDTO }>({
      query: ({ origin, body }) => ({
        url: "/search-analytics/no-result-search-logs",
        method: "POST",
        headers: { origin },
        body,
      }),
    }),
  }),
});

export const {
  useSaveSearchAnalyticsMutation,
  useSaveNoResultSearchAnalyticsMutation,
} = SearchAnalyticsApiSlice;
